/* eslint-disable jsx-a11y/media-has-caption */
import * as React from 'react';
import _ from 'lodash';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Preloader, MakoAnalytics } from 'client/components/common';
import { fileLink, analytics } from 'common/utils';
// import { USER_SELECTION_MAX_AMOUNT, THANKS_ROUTE, CATEGORY_ROUTE, ROOT_ROUTE } from 'client/constants';
import { ROOT_ROUTE, CLOSED_VOTES_ROUTE, THANKS_ROUTE, CATEGORY_TITLES } from 'client/constants';

import StatusBar from './StatusBar';
import Item from './Item';
import ItemPicture from './ItemPicture';
import ModalLimit from './ModalLimit';
import Search from './Search';
import SelectSongs from './SelectSongs';
import SelectImage from './SelectImage';
import * as css from './Category.scss';
// import CreditPhotographer from '../../common/CreditPhotographer';

class Category extends React.PureComponent {
	audio = null;

	static propTypes = {
		items: PropTypes.shape({}),
		isFetching: PropTypes.bool.isRequired,
		categoryId: PropTypes.string.isRequired,
		getItems: PropTypes.func.isRequired,
		getCategories: PropTypes.func.isRequired,
		changeCategory: PropTypes.func.isRequired,
		categories: PropTypes.shape({}).isRequired,
		history: PropTypes.shape({
			push: PropTypes.func.isRequired,
		}).isRequired,
		getCategorySelection: PropTypes.func.isRequired,
		setCategorySelection: PropTypes.func.isRequired,
		submitSelection: PropTypes.func.isRequired,
		isScrolling: PropTypes.bool.isRequired,
		user: PropTypes.shape({}),
	};

	static defaultProps = {
		items: {},
		user: null,
	};

	constructor(props) {
		super(props);

		this.isRedirected = false;

		this.state = {
			showModalLimit: false,
			selectedItems: [],
			isSubmitted: false,
			currentItemId: null,
			searchResult: '',
			sortedItems: null,
			isAuthorSelected: false,
			openSongPopup: false,
			categoryOrder: 0,
			isAudioPlaying: false,
		};
	}

	componentDidMount = async () => {
		const selection = await this.props.getCategorySelection({ categoryId: this.props.categoryId });

		if (_.get(selection, 'isSelectionSubmitted') || _.get(this.props, 'user.isSelectionSubmitted', false)) {
			this.setState({ isSubmitted: true });
		} else {
			this.setState({ isSubmitted: false, selectedItems: selection.selectedItems });
			await this.props.getItems(this.props.categoryId);
		}

		if (_.isEmpty(this.props.categories)) {
			await this.props.getCategories();
		}

		const { categoryId, categories } = this.props;
		const currentCategory = _.find(categories, ['id', categoryId]);

		this.setState({ sortedItems: this.sortedItems, categoryOrder: _.get(currentCategory, 'order') });
	};

	componentWillUnmount() {
		if (this.audio) {
			this.audio.pause();
			this.audio.removeEventListener('ended', this.onAudioEndedListener);
		}
	}

	get isAllowSelect() {
		const { categoryId, categories } = this.props;
		const currentCategory = _.find(categories, ['id', categoryId]);
		return this.state.selectedItems.length !== +_.get(currentCategory, 'max');
	}

	get sortedItems() {
		const sortedItems = _.map(this.props.items, o => o).sort((a, b) => {
			const aName = a.title;
			const bName = b.title;

			if (aName < bName) return -1;
			if (aName > bName) return 1;

			return 0;
		});

		const groups = _.reduce(
			sortedItems,
			(acc, item, index) => {
				acc.push({ letter: item.title.charAt(0), ...item });
				return acc;
			},
			[]
		);

		const shuffledGroups = _.shuffle(_.groupBy(groups, 'letter'));

		return shuffledGroups;
	}

	getUserId = () => {
		return localStorage.getItem('__uid__v2');
	};

	getIsVotedOnce = () => {
		return localStorage.getItem('__f__v2');
	};

	getIsUserWasOnThanksPage = () => {
		return localStorage.getItem('isFirstVisitv2');
	};

	onItemClick = itemId => {
		const { categoryId } = this.props;
		let { selectedItems } = this.state;

		if (selectedItems.includes(itemId)) {
			// remove
			selectedItems = _.filter(this.state.selectedItems, id => id !== itemId);
		} else if (itemId && this.isAllowSelect) {
			// add
			selectedItems = [...this.state.selectedItems, itemId];
		}

		this.setState({ selectedItems });

		this.props.setCategorySelection({ categoryId, selectedItems });
	};

	onPlayClick = id => {
		const { currentItemId } = this.state;
		const fileURL = fileLink(_.get(this.props.items, `${id}.file`, ''));
		// eslint-disable-next-line react/prop-types
		// const { title: songName } = this.props.items[`${id}`];
		if (this.audio) {
			this.audio.pause();
			this.audio.removeEventListener('ended', this.onAudioEndedListener);
			this.audio.removeEventListener('play', this.onAudioPlayListener);
		}

		this.setState({ isAudioPlaying: false });

		if (currentItemId === id) {
			this.setState({ currentItemId: null });
		} else {
			this.audio = new Audio(fileURL);
			this.audio.play().catch(_.noop);
			this.audio.addEventListener('play', this.onAudioPlayListener);
			this.audio.addEventListener('ended', this.onAudioEndedListener);
			this.setState({ currentItemId: id });
		}
	};

	onAudioEndedListener = () => {
		this.setState({ currentItemId: null });
		this.setState({ isAudioPlaying: false });
	};

	onAudioPlayListener = () => {
		this.setState({ isAudioPlaying: true });
	};

	searchResult = searchItem => {
		this.setState({ searchResult: searchItem });
	};

	onCloseModal = () => {
		this.setState({ showModalLimit: false, openSongPopup: true });
	};

	onShowModal = () => {
		this.setState({ showModalLimit: true, openSongPopup: false });
	};

	onFinishClick = async token => {
		const { categories, categoryId } = this.props;
		const { selectedItems, categoryOrder, isSubmitted } = this.state;

		await this.props.submitSelection({ categoryId, selectedItems, token });

		const nextOrder = categoryOrder + 1;
		const nextCategory = _.find(categories, ['order', nextOrder]);
		const nextCategoryId = _.get(nextCategory, 'id');

		this.setState({ categoryOrder: nextOrder });
		console.info(isSubmitted);

		if (nextOrder < _.size(categories)) {
			if (nextOrder === 1) analytics.gtag.event('סיום שלב א הצבעה לשיר השנה');
			if (nextOrder === 2) analytics.gtag.event('סיום שלב ב הצבעה לאנשי השנה');
			if (nextOrder === 3) analytics.gtag.event('סיום שלב ג הצבעה לאלבום השנה');
			if (nextOrder === 4) analytics.gtag.event('סיום שלב ד הצבעה להופעת השנה');
			this.props.changeCategory(nextCategoryId);
		} else {
			analytics.gtag.event('סיום שלב ה הצבעה לשיר הגרוע של השנה');
			localStorage.setItem('__f__v2', true);
			this.props.history.push(THANKS_ROUTE);
		}
	};

	renderItems = () => {
		const { categories, categoryId } = this.props;
		const category = _.find(categories, ['id', categoryId]);

		return _.map(this.state.sortedItems, group => {
			return _.map(group, item => {
				return (
					<React.Fragment key={item.id}>
						{category?.isImageTemplate ? (
							<ItemPicture
								className={css.itemPicture}
								isSelected={this.state.selectedItems.includes(item.id)}
								isAllowSelect={this.isAllowSelect}
								isFirstByLetter={item.isFirstByLetter || false}
								onItemClick={this.onItemClick}
								onShowModal={this.onShowModal}
								// searchResult={this.state.searchResult}
								isAuthorSelected={this.state.isAuthorSelected}
								title={item.title}
								subtitle={item.subtitle}
								id={item.id}
								file={item.file}
								order={this.state.categoryOrder}
							/>
						) : (
							<Item
								isSelected={this.state.selectedItems.includes(item.id)}
								isAllowSelect={this.isAllowSelect}
								isPlaying={item.id === this.state.currentItemId}
								isAudioPlaying={this.state.isAudioPlaying}
								isFirstByLetter={item.isFirstByLetter || false}
								onItemClick={this.onItemClick}
								onPlayClick={this.onPlayClick}
								onShowModal={this.onShowModal}
								searchResult={this.state.searchResult}
								isAuthorSelected={this.state.isAuthorSelected}
								title={item.title}
								subtitle={item.subtitle}
								id={item.id}
								file={item.file}
							/>
						)}
					</React.Fragment>
				);
			});
		});
	};

	removeItemForList = id => {
		this.onItemClick(id);
	};

	setIsAuthorSelected = value => {
		this.setState({ isAuthorSelected: value });
	};

	chunkSong = () => {
		if (_.isEmpty(this.props.items)) {
			return [[], []];
		}
		const selectSong = this.state.selectedItems.map(id => this.props.items[id]);
		const chunk = _.chunk(selectSong, Math.ceil(_.size(selectSong) / 2));
		return chunk.length === 1 ? [[], ...chunk] : chunk;
	};

	onSelectSongsClick = () => {
		this.openSongPopupHandler();
	};

	onSelectImageClick = () => {
		this.openSongPopupHandler();
	};

	openSongPopupHandler = () => {
		this.setState({ openSongPopup: false });
	};

	render() {
		const { isFetching, categories, categoryId, isScrolling } = this.props;
		const { showModalLimit, openSongPopup, sortedItems } = this.state;
		const category = _.find(categories, ['id', categoryId]);

		const minCount = _.get(category, 'min', 3);
		const maxCount = _.get(category, 'max', 15);
		const noItems = _.size(this.props.items) <= 0;

		if (!this.getUserId()) {
			return <Redirect to={ROOT_ROUTE} />;
		}

		if (this.getIsVotedOnce() && this.getIsUserWasOnThanksPage()) {
			return <Redirect to={CLOSED_VOTES_ROUTE} />;
		}

		const vcmIds = ['votesongs', 'voteartist', 'votealbum'];
		const vcmId = vcmIds[this.state.categoryOrder];

		return (
			<React.Fragment>
				{/* {category?.isImageTemplate && <CreditPhotographer />} */}
				<div className={css.categoryHeader}>
					<h4 className={classNames(css.categoryTitle, { [css.isScrolling]: isScrolling })}>
						{CATEGORY_TITLES[categoryId].categoryTitle}
					</h4>
					{!noItems && category && !category?.isImageTemplate && sortedItems && (
						<Search
							allSongs={sortedItems}
							searchResult={this.searchResult}
							isScrolling={isScrolling}
							setIsAuthorSelected={this.setIsAuthorSelected}
						/>
					)}
				</div>
				<div className={css.categoryWrapper}>
					<div
						className={classNames(
							css.categoryContent,
							_.get(category, 'order', 0) === 2 && css.albumsGrid,
							_.get(category, 'order', 0) === 3 && css.albumsGrid,
							_.get(category, 'order', 0) === 4 && css.albumsGrid,
							_.get(category, 'order', 0) === 1 && css.artistsGrid
						)}
					>
						{!noItems && !isFetching ? this.renderItems() : <Preloader />}
					</div>
				</div>
				<StatusBar
					count={this.state.selectedItems.length}
					onFinishClick={this.onFinishClick}
					minCount={+minCount}
					maxCount={+maxCount}
					nameHE={CATEGORY_TITLES[categoryId].nameHE}
				/>
				{vcmId && <MakoAnalytics vcmId={vcmId} />}
				{!noItems && !isFetching && category && !category.isImageTemplate && (
					<SelectSongs
						dataSongsId={this.state.selectedItems}
						removeItemForList={this.removeItemForList}
						onPlayClick={this.onPlayClick}
						items={this.chunkSong()}
						openSongPopup={openSongPopup}
						openSongPopupHandler={this.onSelectSongsClick}
						isImageTemplate={category?.isImageTemplate}
						// onToggleDrawer={this.onSongsToggleDrawer}
					/>
				)}
				{!noItems && !isFetching && category && category?.isImageTemplate && (
					<SelectImage
						dataSongsId={this.state.selectedItems}
						removeItemForList={this.removeItemForList}
						items={this.chunkSong()}
						openSongPopup={openSongPopup}
						openSongPopupHandler={this.onSelectImageClick}
						isImageTemplate={category?.isImageTemplate}
						// onToggleDrawer={this.onImageToggleDrawer}
					/>
				)}
				<ModalLimit
					in={showModalLimit}
					onCloseModal={this.onCloseModal}
					nameHE={CATEGORY_TITLES[categoryId].nameHE}
					maxLimit={`${maxCount}`}
					order={this.state.categoryOrder}
				/>
			</React.Fragment>
		);
	}
}

export default Category;
